
import React from 'react';
import { Card, CardContent, Typography, Grid, IconButton, Box } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

export const GenericCard = ({ row, columns, onEdit, onDelete, permissions, customActions }) => {
    // Filter columns to exclude 'id' and 'acciones' or hidden columns if necessary
    // For now, we'll show all columns except 'id' to avoid redundancy if it's shown in header/caption
    // or we can show 'id' smaller.

    const displayColumns = columns.filter(col => col.field !== 'id' && col.field !== 'acciones');

    return (
        <Card sx={{ marginBottom: 2 }}>
            <CardContent>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        {/* ID as a small caption or similar */}
                        <Typography variant="caption" color="textSecondary">
                            ID: {row.id}
                        </Typography>
                    </Grid>

                    {displayColumns.map((col) => (
                        <Grid item xs={12} key={col.field}>
                            <Typography variant="subtitle2" component="span" style={{ fontWeight: 'bold' }}>
                                {col.headerName}:
                            </Typography>
                            <Typography variant="body2" component="span" style={{ marginLeft: 5 }}>
                                {/* Handle custom renderCell if it exists, otherwise raw value */}
                                {/* Since renderCell might return a React component, we might need to handle it carefully.
                             For simple ABMGenerico usage, we often have direct values. 
                             If renderCell exists and is a function, we could try to call it, 
                             but it expects params. Let's try to output raw value first or simple transformation.
                         */}
                                {col.renderCell
                                    ? col.renderCell({ row, value: row[col.field], colDef: col })
                                    : typeof row[col.field] === 'object' && row[col.field] !== null
                                        ? JSON.stringify(row[col.field])
                                        : row[col.field]}
                            </Typography>
                        </Grid>
                    ))}

                    <Grid item xs={12} container justifyContent="flex-end" style={{ marginTop: 10 }}>
                        {/* Permissions might differ per usage, but usually standard edit/delete */}
                        {/* If permissions are not passed, we assume true or check internal logic */}

                        {/* Custom actions via getActions array */}
                        {customActions}

                        {/* Check if onEdit is provided */}
                        {onEdit && (
                            <IconButton onClick={() => onEdit(row)} size="small" color="primary">
                                <EditIcon />
                            </IconButton>
                        )}

                        {/* Check if onDelete is provided */}
                        {onDelete && (
                            <IconButton onClick={() => onDelete(row.id)} size="small" color="error">
                                <DeleteIcon />
                            </IconButton>
                        )}
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};
